export enum WalletTransactionType {
  REDEEM = 'redeem',
  REVERSAL = 'reversal',
  TOP_UP = 'top_up',
  TRANSFER_IN = 'transfer_in',
  TRANSFER_OUT = 'transfer_out'
}

export enum WalletAccountTypeId {
  LITE = 'lite',
  PRO = 'pro'
}

export enum WalletRedeemStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  PROCESSED = 'processed',
  REJECTED = 'rejected'
}

export enum WalletTransferStatus {
  CANCELED = 'canceled',
  EXECUTED = 'executed',
  PENDING = 'pending'
}

export const NUMBER_ITEMS_PER_REQUEST = 10;
export const MIN_REDEEM_AMOUNT = 10000;
export const MIN_TRANSFER_AMOUNT = 5000;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/wallet.ts